/**
 * Los dias en que una persona trabaja un horario de biblioteca. Se cuentan
 * como date.weekday() de Python, que es lo que guarda el backend: 0 es lunes
 * y 6 domingo. Sin React.
 */

export const DIAS = [
  { valor: 0, corto: "L", nombre: "Lunes" },
  { valor: 1, corto: "M", nombre: "Martes" },
  { valor: 2, corto: "X", nombre: "Miércoles" },
  { valor: 3, corto: "J", nombre: "Jueves" },
  { valor: 4, corto: "V", nombre: "Viernes" },
  { valor: 5, corto: "S", nombre: "Sábado" },
  { valor: 6, corto: "D", nombre: "Domingo" },
];

/**
 * [0, 1, 2, 3, 4] -> "Lunes a viernes"; [0, 2, 4] -> "Lunes, miércoles y
 * viernes"; los siete -> "Todos los días".
 */
export const describirDias = (dias = []) => {
  const orden = [...dias].sort((a, b) => a - b);
  if (orden.length === 0) return "Sin días";
  if (orden.length === DIAS.length) return "Todos los días";

  const nombres = orden.map((dia) => DIAS[dia].nombre.toLowerCase());
  const seguidos = orden.every((dia, i) => i === 0 || dia === orden[i - 1] + 1);
  const texto =
    seguidos && orden.length > 2
      ? `${nombres[0]} a ${nombres[nombres.length - 1]}`
      : nombres.length === 1
        ? nombres[0]
        : `${nombres.slice(0, -1).join(", ")} y ${nombres[nombres.length - 1]}`;
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

